/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Watch} from "vue-property-decorator";
import {UserModule} from '@/store/modules/user'
import {
    getCustomerListByEduCode,
    getFinanceOrderListByFinanceRepeatOrder,
    getFinanceRepeatOrderById, setFinanceRepeatOrderById,

} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import {formatDate} from '@/utils/timeFilter'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class RepeatOrderInfo extends Vue {
    select = '0'
    tableData = []
    logList = []
    tableRandom = Math.random()
    tableKey = Math.random()
    formData = {
        repeatUserRealName: '',
        repeatUserId: '',
        explain: '',

        financeOrderId: '',
        financeRepeatOrderExplainList: [],
        url: '',
        name: '',
        aRatio: '',
        bRatio: '',
        customerEduCode :''
    }
    amount: ''
    fileList = []
    orderDialogSelectTable = [] //选中数据
    tableDataOrder = [] //明细列表
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'
    backMoneyId: number = null
    orderId: number = null
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 草稿id

    operationShow = true
    backMoneyStatus = ''
    showInput: any = false
    type = ""
    status: any
    repeatOrderId = NaN
    isUpdatedData = '0'
    orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogTotal = 0
    orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelect = {
        id: null, //订单id
        code: '', //订单code
        price: '', //订单金额
    }
    currentPage = 1
    pagesize = 20
    customerName = ''
    sourceName = ''
    isShow: any
    disabledBtn = false
    loading = false

    formRules = {
        // types: [{required: true, message: '请选择费用类型', trigger: 'change'}],
        // financeOrderCode: [{required: true, message: '请选择订单', trigger: ['change', 'blur']}],
        // reason: [{required: true, message: '请输入申请原因', trigger: 'blur'}],
        // price: [{required: true, message: '请输入金额', trigger: ['change', 'blur']}],
    }
    isRules = false

    previewPath = []
    previewVisible = false
    orderSelected = {}
    activities =  []
    directorUserRealName=  ''
    directorUserId=  ''
    createdUserRealName = ''
    createdAt = ''
    orderAllPrice = ''
    uploadData = {
        bucket: 'crm',
        signature: ''
    }

    get elImageUrls() {
        return this.fileList ? this.fileList.map(item => item.url) : []
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    get userName() {
        return UserModule.userName
    }


    // get orderAllPrice() {
    //     return this.tableDataOrder[0].financeOrderPrice
    // }


    menuBtn = menuBtn
    formatDate = formatDate


    created() {
        this.repeatOrderId = Number(this.$route.query.id)
        this.status = this.$route.query.status
        this.isShow = this.$route.query.isShow
        this.type = this.$route.query.type as string
        if (this.$route.query.isUpdatedData) {
            this.isUpdatedData = this.$route.query.isUpdatedData as string
        }
        if (this.type) {
            this.showInput = true
        }

        this.getFinanceRepeatOrderById()

    }

    beforeUpload (file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }

    handlePreview(file) {
        this.previewPath = [file.url]
        this.previewVisible = true
    }

    uploadSuccess(response, file, fileList) {
        // const {data} = res
        // this.$message.success('上传成功')
        // this.fileList.push({name: data.name, url: data.ossUrl})
        if (fileList.every(item => item.status == 'success')) {
            this.formData.financeRepeatOrderExplainList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功');
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }

    uploadError() {
        this.$message.error('上传失败')
    }

    handleUploadRemove(file) {
        this.formData.financeRepeatOrderExplainList = this.formData.financeRepeatOrderExplainList.filter(item => item.uid !== file.uid)
    }

    // 详情
    async getFinanceRepeatOrderById() {
        this.loading = true
        await getFinanceRepeatOrderById(
            {
                id: this.repeatOrderId,
                isUpdatedData: this.isUpdatedData
            }).then((res:any)=>{

        this.tableDataOrder = [res.financeRepeatOrder.financeRepeatOrderDetail]
        this.formData.financeOrderId = res.financeRepeatOrder.financeRepeatOrderDetail.financeOrderId

        this.formData = res.financeRepeatOrder

        this.fileList = this.formData.financeRepeatOrderExplainList

        this.editUserName = res.financeRepeatOrder.createdUserRealName
        this.logList = res.financeRepeatOrder.financeRepeatOrderLogList
        this.amount = res.financeRepeatOrder.financeRepeatOrderDetail.financeOrderPrice
        this.directorUserId = res.financeRepeatOrder.financeRepeatOrderUser.directorUserId
        this.directorUserRealName = res.financeRepeatOrder.financeRepeatOrderUser.directorUserRealName
        this.createdUserRealName = res.financeRepeatOrder.financeRepeatOrderUser.createdUserRealName
        this.createdAt = res.financeRepeatOrder.createdAt

        //    审批流程
        this.activities = res.financeRepeatOrder.messageReviewList
        this.loading = false
        }).catch(()=>{
            this.loading = false
        })
    }

    // 明细删除
    clickDelOrder(row) {
        this.tableDataOrder = this.tableDataOrder.filter(item => item.financeOrderId ? item.financeOrderId !== row.financeOrderId : item.id !== row.id)
        this.orderDialogSelectTable = this.orderDialogSelectTable.filter(item => item.id ? item.id !== row.id : item.financeOrderId !== row.financeOrderId)
        // this.tableDataOrder = this.tableDataOrder.filter(item => item.financeOrderId !== row.financeOrderId)
        // this.orderDialogSelectTable = this.orderDialogSelectTable.filter(item => item.financeOrderId !== row.financeOrderId)
        this.tableDataOrder.forEach(row => {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row, true)
        })
    }

    edit() {
        this.showInput = true
    }

    clickAddOrder() {
        this.orderDialog = true
        this.getFinanceOrderListByFinanceRepeatOrder()
        this.defaultChecked()
    }

    defaultChecked() {
        this.$nextTick(() => {
            const order = (this.$refs.orderDialogTable as HTMLFormElement)
            order.clearSelection();
            this.tableDataOrder.forEach(row => {
                order.toggleRowSelection(row, true)
            })
        })
    }

    changeCustomerEduCode(val) {
        if (val) {
            getCustomerListByEduCode({
                customerEduCode: val
            }).then((res: any) => {
                this.formData.repeatUserId = res.customerDirectorUserId
                this.formData.repeatUserRealName = res.customerDirectorUserRealName
            })
        } else {
            this.formData.repeatUserId = ''
            this.formData.repeatUserRealName = ''
        }
    }
    // 编辑保存
    saveEditMarketCost() {

        const obj = {
            id: this.repeatOrderId,//    撞单id
            repeatUserId: this.formData.repeatUserId,//    撞单同事
            financeOrderId: this.tableDataOrder[0].id ? this.tableDataOrder[0].id : this.formData.financeOrderId,//    订单id
            explain: this.formData.explain,//    撞单说明（文字）
            financeRepeatOrderExplainList: this.formData.financeRepeatOrderExplainList, //    撞单说明（图片）
            url: this.formData.url,//    图片链接
            name: this.formData.name,//    图片名称
            directorUserId: this.directorUserId,//负责人id
            customerEduCode: this.formData.customerEduCode,//客户编号
        };
        (this.$refs['formRef'] as HTMLFormElement).validate((valid: boolean) => {
            if (valid) {
                this.disabledBtn = true
                this.loading = true
                setFinanceRepeatOrderById(delNullProperty(obj)).then(() => {
                    this.$message.success('编辑成功')
                    this.loading = false
                    setTimeout(() => {
                        window.close()
                        this.$router.push({
                            path: 'marketCost',
                            query: {}
                        })
                    }, 1500)
                }).catch((err: Error) => {
                    if (err.message === '审批流报错') {
                        this.errorDialogShow = true
                    }
                    this.disabledBtn = false
                    this.loading=  false
                })
            }
        })
    }

    // 选过的订单不可选
    orderTableSelect(row) {
        return row.isSelect == '1'
    }


    // 订单/回款列表change
    handleOrderFilter(val) {
        this.select = val
        this.orderDialogInputValue = ''
    }

    // 选择订单列表
    choiceOrder(e) {
        this.orderDialog = true
        this.currentPage = 1
        this.getFinanceOrderListByFinanceRepeatOrder()
        e.target.blur()
    }


    getRowKeys(row) {
        return row.id ? row.id : row.financeOrderId

    }


    // 订单
    handleOrderRowClick(row) {
        (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }

    closePage() {
        window.close()
    }


    changeTypes(e) {
        if (e == 1) {
            this.isRules = false
        } else {
            this.isRules = true
        }

    }

    // 订单列表搜索
    async clickorderDialogFilter() {
        if (this.select == '0') { //客户名称
            this.customerName = this.orderDialogInputValue
            this.sourceName = ''
        }
        this.currentPage = 1
        this.getFinanceOrderListByFinanceRepeatOrder()
    }

    clickOrderDialogTableRow(row) {
        if (row.isSelect == '1') {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }


    // 订单列表确定事件
    orderDialogConfirm() {
        this.tableDataOrder = []
        this.orderDialogSelectTable.map(item => {
            const Index = this.tableDataOrder.findIndex((items) => {
                return items.id === (item.financeOrderId ? item.financeOrderId : item.id)
            })
            if (Index == -1) {
                this.tableDataOrder.push({
                    ...item,
                    financeOrderCode: item.financeOrderCode ? item.financeOrderCode : item.code,
                    financeOrderPrice: item.financeOrderPrice ? item.financeOrderPrice : item.price,
                    priceOrScore: item.priceOrScore ? item.priceOrScore : 0,
                })
            }
        })
        this.orderDialog = false
        this.orderDialogInputValue = ''

    }

    handleorderRowClick(row) {
        if (row.isSelect == '1') {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }

    // 订单列表change
    orderDialogSelectionChange(selectionArr: any[]) {
        this.orderDialogSelectTable = selectionArr
        if (selectionArr.length > 0) {
            this.orderSelected = JSON.parse(JSON.stringify(selectionArr[0]))
            if (selectionArr.length > 1) {
                const orderTable = this.$refs.orderDialogTable as HTMLFormElement
                orderTable.clearSelection()
                orderTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.orderSelected) {
                this.orderSelected[key] = null
            }
        }
    }

    // 订单弹框取消
    doCancel() {
        this.orderDialogSelectTable.map(item => {
            this.tableDataOrder.map(items => {
                if (item.financeOrderId !== items.financeOrderId) {
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if (this.tableData.length > 0) {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row, true)
            });
        } else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }


    // 订单列表
    async getFinanceOrderListByFinanceRepeatOrder() {
        this.orderDialogTableLoading = true
        const obj = {
            financeRepeatOrderId: this.repeatOrderId,
            customerName: this.customerName,
            page: this.currentPage,
            limit: this.pagesize,
            source: this.sourceName,
        }
        await getFinanceOrderListByFinanceRepeatOrder(delNullProperty(obj)).then((data: any) => {
            this.orderDialogTaleData = data.financeOrderList
            this.orderDialogTotal = data.allNum
            this.orderDialogTableLoading = false
        }).catch(() => {
            this.orderDialogTableLoading = false
        })



        //    回显
        this.orderDialogTaleData.forEach(row => {
            // debugger
            if (row.id == (this.tableDataOrder[0].id ? this.tableDataOrder[0].id : this.formData.financeOrderId)) {
                (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
            }
        })
    }


    handleSizeChange(val) {
        this.pagesize = val
        this.getFinanceOrderListByFinanceRepeatOrder();
    }

    handleCurrentChange(val) {
        this.currentPage = val
        this.getFinanceOrderListByFinanceRepeatOrder();
    }


    //获得年月日时分秒
//传入日期//例：2020-10-27T14:36:23
    timeFormatSeconds(time) {
        if (!time) {
            return ''
        }
        const d = time ? new Date(time) : new Date();
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate();
        let hours = d.getHours();
        let min = d.getMinutes();
        let seconds = d.getSeconds();

        if (month < 10) {
            (month as any) = '0' + month;
        }
        if (day < 10) (day as any) = '0' + day;
        if (hours < 0) (hours as any) = '0' + hours;
        if (min < 10) (min as any) = '0' + min;
        if (seconds < 10) (seconds as any) = '0' + seconds;

        return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
    }

    changeDirectorUserId(e) {
        this.directorUserId = e.id
    }

    @Watch('tableDataOrder', {deep: true})
    handle(val){
        this.orderAllPrice = val[0].financeOrderPrice
    }
}
